module.exports = __webpack_public_path__ + "assets/d922cf5a2c8e42e87536738e8c4b8abf.mp4";